import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const EditScheduleForm = lazyLoader(
  () => import("Containers/Schedules/EditSchedule/EditSchedule")
);

export const EditSchedule = () => {
  return (
    <Layout>
      <EditScheduleForm isEdit={true} />
    </Layout>
  );
};
